// Captcha-EU initialisieren
if ($('.ttgAnfrageFormSubmitButton.recaptcha').data('publickey') != '') {
    KROT.setup($('.ttgAnfrageFormSubmitButton.recaptcha').data('publickey'));
}

/* PARSLEY */
$('.ttgAnfrageForm').parsley();

window.Parsley.on('field:error', function() {
    this.$element.attr('aria-describedby', this._ui.errorsWrapperId).attr('aria-invalid', 'true');
});

window.Parsley.on('field:success', function() {
    if (this.$element.attr('aria-invalid')) {
        this.$element.removeAttr('aria-invalid');
    }
});

/* FOOTER-FORMULAR */
// Formular im Footer positionieren
if ($('#ttgFooterWrapper').length > 0) {
    if ($('.ttgAnfrageContainerFooter').length > 0) {
        $('.ttgAnfrageContainerFooter').appendTo("#ttgFooterWrapper");

        if ($(window).width() >= 1170) {
            $('.ttgAnfrageContainerFooter').parent().addClass('open');
        }

        // aktuelle URL setzen
        var currentURL = window.location.href;
        $('.ttgAnfrageFormFooter input[type="hidden"][name="currenturl"]').val(currentURL);
    }
}

/* FANCY-FORMULARE */
// Formular anzeigen / TOURDATA
$('body').on('click', 'a[href="#mailto"]', function(e) {

    // Empfänger-Adresse
    var mailtoAdress = $(this).attr('data-href');

    if ($(this).hasClass('ttgFormTypeUnterkunft')) {
        showForm(e, 'ttgUnterkunftTemplateWrapper', mailtoAdress);
        openDialog("ttgUnterkunftTemplateWrapper", $(this));
    } else if ($(this).hasClass('ttgFormTypeLocation')) {
        showForm(e, 'ttgLocationTemplateWrapper', mailtoAdress);
        openDialog("ttgLocationTemplateWrapper", $(this));
    } else if ($(this).hasClass('ttgFormTypeFeedback')) {
        showFeedbackForm(e, 'ttgFeedbackTemplateWrapper');
        openDialog("ttgFeedbackTemplateWrapper", $(this));
    } else {
        showForm(e, 'ttgFancyTemplateWrapper', mailtoAdress);
        openDialog("ttgFancyTemplateWrapper", $(this));
    }

    // aktuelle URL setzen
    var currentURL = window.location.href;
    $('input[type="hidden"][name="currenturl"]').val(currentURL);
    var objektPlz = $('#objektPlz').html();
    $('input[type="hidden"][name="objektPlz"]').val(objektPlz);
    var objektOrt = $('#objektOrt').html();
    $('input[type="hidden"][name="objektOrt"]').val(objektOrt);

    // wenn das crm-package Feld vorhanden ist, und auch die TOURDATA ID vorhanden ist, dann das Feld befüllen
    if ($('.ttgTourdataDetailseitePauschale').data('sourceid') > 0 && $('input.crm-package').length > 0) {
        $('input.crm-package').val($('.ttgTourdataDetailseitePauschale').data('sourceid'));
    }
});

// Formular anzeigen / redaktionell
$('a[href^="mailto:"]').click(function(e) {
    if ($('.ttgDataWrapperOnlyNeededForJS').attr('data-disableFancy') == 1) {
        return;
    } else if ($(this).hasClass('open-email-client')) {
        // um beim einem Klick auf eine mailto Verlinkung mit class open-email-client den Mail-Client zu öffnen und nicht nach oben zu scrollen
        return;
    } else {
        // Empfänger-Adresse
        var mailtoAdress = $(this).attr('href');
        var mailAdress = mailtoAdress.replace("mailto:", "");

        showForm(e, 'ttgFancyTemplateWrapper', mailAdress);
    }
});

// Formular schließen
$('.ttgAnfrageSchliessen').click(function() {
    $(this).parent().parent().hide();

    // Opacity wieder auf 1 setzen
    // $('.ttgContent').css('opacity', '1');
    // $('.ttgFooter').css('opacity', '1');
    $('body').removeClass('has-dialog');
    $('body').find('.cc-window-backdrop').remove();

    closeDialog(this);
});

// Formular mit ESC schließen
$('body').on('keydown', '.ttgAnfrageSchliessen', function(e) {
    var code = e.which;
    // 27 = ESC
    if ((code === 27)) {
        $(this).click();
    }
});

// beim Drücken von ESC, das Formular schließen
$(document).keyup(function(e) {
    if (e.keyCode == 27) {
        $('.ttgAnfrageSchliessen').trigger('click');
    }
});

/* BUCHUNGSBLOCK */
if ($('.ttgFormBuchungsblock').length) {

    // Reisezeitraum unbekannt - Checkbox
    $('.ttgFormReisezeitraumUnbekannt').change(function() {
        $('#anreiseForm').prop('disabled', function(i, v) {
            return !v;
        });
        $('#abreiseForm').prop('disabled', function(i, v) {
            return !v;
        });
    });

    var today = formatDateforDatepicker(new Date());

    $("#anreiseForm").attr("min", today);
    $("#anreiseForm").val(today);
    $("#abreiseForm").attr("min", today);
    $("#abreiseForm").val(today);

    $('#anreiseForm').change(function() {
        $("#abreiseForm").trigger('focus');
        $("#abreiseForm").attr("min", $("#anreiseForm").val());
        $("#abreiseForm").val($("#anreiseForm").val());
    });

    $('#anreiseForm').keypress(function(e) {
        $(this).off('change blur');

        $(this).blur(function() {
            $("#abreiseForm").trigger('focus');
            $("#abreiseForm").attr("min", $("#anreiseForm").val());
            $("#abreiseForm").val($("#anreiseForm").val());
        });
    });

    // Anzahl der Kinder
    if ($("#anzahlKinder").length) {
        $("#anzahlKinder").change(function() {
            if ($(this).val() > 0) {
                $(".ttgFormKinderAlterSelectWrapper").show();
                formChangeTextKinder();
            } else {
                $(".ttgFormKinderAlterSelectWrapper").hide();
            }
        });
    }
}

/* UNTERKUNFTS-DETAILSEITE - Werte aus Buchenbox in Anfrageformular übertragen */
$('.ttgTourdataDetailseiteVermieter, #resultCol.buchenFilterV2Visible').on('click', '.ttgFormTypeUnterkunft', function() {
    $bF = $('.buchenFilter.v2');

    var dateArr = $bF.find('.sumUpData .sumUp_an').text().split(".");
    var anreiseDate = dateArr[2] + '-' + dateArr[1] + '-' + dateArr[0];
    dateArr = $bF.find('.sumUpData .sumUp_ab').text().split(".");
    var abreiseDate = dateArr[2] + '-' + dateArr[1] + '-' + dateArr[0];

    $('.ttgAnfrageFormUnterkunft #anreiseForm').val(anreiseDate);
    $('.ttgAnfrageFormUnterkunft #abreiseForm').val(abreiseDate);
    $('.ttgAnfrageFormUnterkunft #anzahlZimmer option[value=' + $bF.find('.sumUpData .sumUp_zimmer').text() + 'xZimmer]').prop('selected', 'selected');

    if (parseInt($bF.find('.sumUpData .sumUp_zimmer').text()) > 1) {
        $('.ttgAnfrageFormUnterkunft .multiRoomInfo').show();
    } else {
        $('.ttgAnfrageFormUnterkunft .multiRoomInfo').hide();
    }
    $('.ttgAnfrageFormUnterkunft #anzahlErwachsene option[value=' + $bF.find('.sumUpData .sumUp_erwachsene').text() + ']').prop('selected', 'selected');

    $('.ttgAnfrageFormUnterkunft .ttgFormKinderAlterSelectWrapper .form-control').prop('disabled', true).val(-1);
    var kinder = parseInt($bF.find('.sumUpData .sumUp_kinder').text());
    if (kinder > 0) {

        $('.ttgAnfrageFormUnterkunft #anzahlKinder option[value=' + kinder + ']').prop('selected', 'selected');
        $(".ttgFormKinderAlterSelectWrapper").show();

        $.each($bF.find('.zimmerHolder .zimmer:not(".template") .kinderHolder .kind:not(".template") input'), function(i, el) {
            var kindNr = i + 1;
            $('.ttgAnfrageFormUnterkunft #ageKind' + kindNr + ' option[value=' + $(el).val() + ']')
                .prop('selected', true)
                .closest('select').prop('disabled', false);
        });

        if (kinder > 4) {
            $('.ttgAnfrageFormUnterkunft #anzahlKinder option[value=4]').prop('selected', 'selected');

        }

    } else {

        $('.ttgAnfrageFormUnterkunft #anzahlKinder option[value=-1]').prop('selected', 'selected');
        $(".ttgFormKinderAlterSelectWrapper").hide();

    }

});

/* FORMULAR ABSCHICKEN */
$(".ttgAnfrageForm").submit(function(e) {
    var formID = $(this).attr('id');

    var lang = $(this).attr('data-lang');
    var ajaxLoader = 'ttgAnfrageAjaxLoader';

    // Modal
    if ($("#" + formID).parents('.ttgAnfrageFormularModal').length) {
        ajaxLoader = 'ttgAnfrageAjaxLoaderModal';
    } else {
        var formularWrapperID = $(this).parent().attr('id');
        var uid = $(this).parent().data('id');
    }

    // Überprüfung, ob alle Felder korrekt befüllt sind (Parsley)
    if ($(this).find('ul.filled').length != 0) {
        return;
    } else {
        // Default-Reaktion unterbinden und AJAX-Post ausführen
        e.preventDefault();

        //Formular Button deaktivieren
        $("#" + formID + " .ttgAnfrageFormSubmitButton")
            .attr("disabled", "disabled")
            .css('cursor', 'not-allowed');

        if (formularWrapperID) {
            $('#' + formularWrapperID).css("opacity", 0.5);
        }

        // Captcha-EU
        KROT.getSolution()
            .then((solution) => {

                $("#" + formID).find('.captchaeu-solution').val(JSON.stringify(solution));

                $.ajax({
                    type: "POST",
                    url: "/index.php?id=" + rootPage + "&type=3791&L=" + lang,
                    data: $("#" + formID).serialize(),
                    beforeSend: function() {

                        // bei Fancy-Formularen nach dem Submit nach oben scrollen, damit das Ergebnis auch sichtbar ist
                        if ($("#" + formID).hasClass('ttgAnfrageFormFancy')) {
                            $("#ttgKontaktformularScrollToPlatzhalter").animatescroll({
                                padding: 110
                            });
                        }

                        // Ladezustand anzeigen
                        $("." + ajaxLoader).show();

                        // Modal
                        if ($("#" + formID).parents('.ttgAnfrageFormularModal').length) {
                            $(".ttgNCEWrapper").css('z-index', '-1');
                        }
                    },
                    success: function(result) {
                        // Modal
                        if ($("#" + formID).parents('.ttgAnfrageFormularModal').length) {
                            // Ergebnis aus Controller bzw. dessen Template im Modal anzeigen
                            $(".ttgAnfrageFormularModal .modal-body").html(result);

                            // Überschrift aus Body holen und in den Header schreiben
                            var modalID = formID.replace('ttgAnfrageForm', 'anfrageModal');
                            var title = $("#" + modalID + " .ttgAnfrageDankeHeadline h2").text();
                            $(".ttgAnfrageFormularModal .modal-header h4").text(title);
                            $(".ttgAnfrageFormularModal .modal-body .ttgAnfrageDankeHeadline").remove();

                            $(".ttgNCEWrapper").css('z-index', 'auto');
                            //$('body').removeClass('modal-open');
                        }

                        // Ergebnis aus Controller bzw. dessen Template anzeigen (wenn es sich nicht um ein Modal handelt)
                        if (formularWrapperID) {
                            $('#' + formularWrapperID).remove();
                            $("#ttgAnfrageResult" + uid).html(result);
                        }

                        // Ladezustand verstecken
                        $("." + ajaxLoader).hide();

                        if ($('.ttgDataWrapperOnlyNeededForJS').attr('data-googleanalyticsactive') == 1) {
                            var currentURL = window.location.href;
                            trackEvent('Global', 'Kontaktformular', currentURL);
                        }
                    },
                    error: function(xhr, status, error) {
                        alert(xhr.responseText);
                    }
                });
            });
    }
});

$('.ttgAnfrageFormUnterkunft #anzahlZimmer').change(function(e) {
    console.log($(this).val());
    if (parseInt($(this).val()) > 1) {
        $('.ttgAnfrageFormUnterkunft .multiRoomInfo').show();
    } else {
        $('.ttgAnfrageFormUnterkunft .multiRoomInfo').hide();
    }
});

function getFormAnreiseDatumDefaultDay(idElement) {

    if ($("#" + idElement).val() !== "") {
        return $("#" + idElement).val();
    }

    // 0 = sunday, 1 = monday, 2 = tuesday, 3 = wednesday, 4 = thursday, 5=friday, 6 = saturday
    var defaultDay = parseInt($("#" + idElement).attr("data-metasucheanreisedatumdefaultday"));
    var today = new Date();
    var offset = (today.getDay() < defaultDay) ? 0 : 7;
    var daysUntilDefaultDay = defaultDay + offset - today.getDay();
    return '+' + daysUntilDefaultDay + 'd';
}

function getFormAbreiseDatum(idElement, IdElementAn) {

    if ($("#" + idElement).val() !== "") {
        return $("#" + idElement).val();
    }
    var addDays = 1;
    var today = new Date();
    var offset = 1;
    var daysUntilDefaultDay = offset - today.getDay();
    return '+' + (addDays + daysUntilDefaultDay) + 'd';

}

function formChangeTextKinder() {
    var anzahlKinder = $("#anzahlKinder").val();
    $("#amountKinder").html(" - " + anzahlKinder);
    if (anzahlKinder > 1) {
        $("#textKinder").html($("#textKinder").attr('data-textKinderMultiple'));
    } else {
        $("#textKinder").html($("#textKinder").attr('data-textKinderSingle'));
    }

    // alle Kinder Columns sperren
    $(".ttgFormSelectKinder").each(function() {
        var theVal;
        if ($(this).val() < 0) {
            theVal = -1;
        } else {
            theVal = $(this).val();
        }
        $(this).css({
            "opacity": 0.4,
            "cursor": 'not-allowed'
        }).prop('disabled', 'disabled').val(theVal);
    });

    for (var i = 1; i <= anzahlKinder; i++) {
        var val;
        if ($("#ageKind" + i).val() < 0) {
            val = 5;
        } else {
            val = $("#ageKind" + i).val();
        }
        $("#ageKind" + i).css({
            "opacity": 1,
            "cursor": 'default'
        }).prop('disabled', false).val(val);
    }

    var totalAmountKinder = 4;
    /*jslint evil: true */
    var anzahlKinderCounter = eval(parseInt(anzahlKinder) + 1);
    for (var i2 = anzahlKinderCounter; i2 <= totalAmountKinder; i2++) {
        $("#ageKind" + i).prop('disabled', 'disabled').val(-1);
    }

}

function showForm(e, id, empfaenger) {
    // per default hinterlegtes Verhalten zum Öffnen des Links unterbinden
    e.preventDefault();

    // Opacity der restlichen Seite auf 0.5 setzen
    $('body #ttgKontakformularWrapper').append('<div class="cc-window-backdrop modal-backdrop fade in"></div>');

    // $.ajax({
    //     type: "POST",
    //     url: "index.php?id=" + $('#' + id).data("form"),
    //     success: function(response) {
    //         $('#' + id).append($(response).filter('div.ttgAnfrageContainer'));
    //     },
    //     error: function(e) {}
    // }); // ajax

    // Empfänger E-Mail Adresse setzen
    // gegebenenfalls müssen subject und body entfernt werden
    if (empfaenger.indexOf('?') > -1) {
        var empfTmp = empfaenger.split('?');
        if (empfTmp[0]) {
            empfaenger = empfTmp[0];
            var mailSubject = '';
            var mailBody = '';

            var searchSubject = "subject=";
            // Check ob subject= im String vorkommt
            var eTmpIndex = empfTmp[1].indexOf(searchSubject);
            if (eTmpIndex > -1) {
                // Check ob body= im String vorkommt
                var searchBody = "&body=";
                var eTmpBodyIndex = empfTmp[1].indexOf(searchBody);
                if (eTmpBodyIndex > -1) {
                    mailSubject = decodeURIComponent(empfTmp[1].substring((eTmpIndex + searchSubject.length), eTmpBodyIndex));
                    mailBody = decodeURIComponent(empfTmp[1].substring(eTmpBodyIndex + searchBody.length));
                } else {
                    mailSubject = decodeURIComponent(empfTmp[1].substring((eTmpIndex + searchSubject.length), empfTmp[1].length));
                }

                $('#' + id).find('input[type="hidden"][name="empfaengermailSubject"]').val(mailSubject);
                $('#' + id).find('input[type="hidden"][name="empfaengermailBody"]').val(mailBody);
            }
        }
    }
    $('#' + id).find('input[type="hidden"][name="empfaengermail"]').val(empfaenger);
    $('#' + id).find('.mailAddressInfo').text('(' + empfaenger + ')');

    $('#' + id).find('form fieldset').removeAttr('disabled');

    // Höhe des Wrappers berechnen
    var heigthContent = $('.ttgContent').height() + 10;
    // $('#' + id).find('.ttgAnfrageFormular').css('height', heigthContent);

    // verstecktes Formular anzeigen
    $('#' + id).show();

    // nach oben zum Formular srollen
    $("#ttgKontaktformularScrollToPlatzhalter").animatescroll({
        padding: 110
    });

}

function showFeedbackForm(e, id) {
    // per default hinterlegtes Verhalten zum Öffnen des Links unterbinden
    e.preventDefault();

    // Opacity der restlichen Seite auf 0.5 setzen
    $('body #ttgKontakformularWrapper').append('<div class="cc-window-backdrop modal-backdrop fade in"></div>');

    $('#' + id).find('form fieldset').removeAttr('disabled');

    // Höhe des Wrappers berechnen
    var heigthContent = $('.ttgContent').height() + 10;
    // $('#' + id).find('.ttgAnfrageFormular').css('height', heigthContent);

    // verstecktes Formular anzeigen
    $('#' + id).show();

    // nach oben zum Formular srollen
    $("#ttgKontaktformularScrollToPlatzhalter").animatescroll({
        padding: 110
    });

}

var formatDateforDatepicker = function($date) {

    var d = ($date.getDate() < 10) ? '0' + $date.getDate() : $date.getDate();
    var mFix = $date.getMonth() + 1;
    var m = (mFix < 10) ? '0' + mFix : mFix;

    return $date.getFullYear() + '-' + m + '-' + d;
};
